import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import RememberThisDeviceLayout from 'Components/ComponentLibrary/Organisms/RememberThisDevice/RememberThisDeviceLayout';


const RememberThisDevice = () => {
  const {
    resource, onSubmit, handleChange, saving,
  } = useMetaLayoutContext();

  return (
    <RememberThisDeviceLayout
      resource={resource}
      onSubmit={onSubmit}
      handleChange={handleChange}
      saving={saving}
    />
  );
};

export { RememberThisDevice };
